import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management" },
  { title: "menu_sidebar_management_list_management" },
  { title: "menu_sidebar_management_list_management_variant" }
];

const VariantListing = Loadable({
  loader: () => import("container/management/auto/variant"),
  loading() {
    return <Loader />;
  }
});

export const variantRoutes: IRoute[] = [
  {
    path: "/management/variant",
    element: <VariantListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
